import { useQuery } from '@tanstack/react-query';
import api from '@/lib/api';

interface ConfiguracoesBanner {
  bannerAtivo: boolean;
  bannerTexto: string;
  bannerCorFundo: string;
  bannerCorTexto: string;
  bannerLink: string | null;
}

export function useConfiguracoesBanner() {
  return useQuery<ConfiguracoesBanner>({
    queryKey: ['configuracoes-banner'],
    queryFn: async () => {
      const { data } = await api.get('/configuracoes/publico');
      return data;
    },
    staleTime: 5 * 60 * 1000, // 5 minutos
  });
}
